import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function PageHeader({ overline, title, sub, image, breadcrumbs }) {
  return (
    <section data-testid="page-header" className="relative pt-28 md:pt-36 pb-12 md:pb-20 bg-brand-bone overflow-hidden border-b border-brand-line">
      <div className="container-page grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-7">
          {breadcrumbs?.length > 0 && (
            <nav data-testid="breadcrumbs" className="flex items-center gap-1.5 text-xs text-brand-ash mb-6">
              {breadcrumbs.map((b, i) => (
                <span key={i} className="flex items-center gap-1.5">
                  {b.to ? <Link to={b.to} className="hover:text-brand-ink">{b.label}</Link> : <span className="text-brand-ink">{b.label}</span>}
                  {i < breadcrumbs.length - 1 && <ChevronRight className="w-3 h-3" />}
                </span>
              ))}
            </nav>
          )}
          {overline && <p className="overline mb-4">{overline}</p>}
          <h1 className="heading-1 max-w-3xl">{title}</h1>
          {sub && <p className="body-base mt-6 max-w-2xl">{sub}</p>}
        </div>
        {image && (
          <div className="lg:col-span-5">
            <div className="aspect-[5/4] rounded-md overflow-hidden border border-brand-line">
              <img src={image} alt={title} className="w-full h-full object-cover" loading="eager" />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
